import { app } from '../../../../../app';
import { Controller } from './sms-credit.controller';

app.component('companySmsServicesHelpSmsCredit', {
    controller: Controller,
    templateUrl: require('./sms-credit.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/help/sms-credit/sms-credit.component.js